var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullSelectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 4C22.5 2.61929 21.3807 1.5 20 1.5H7C5.61926 1.5 4.5 2.6193 4.5 4V17C4.5 18.3807 5.61927 19.5 7 19.5H20C21.3807 19.5 22.5 18.3807 22.5 17V4ZM20 3.5C20.2761 3.5 20.5 3.72386 20.5 4V17C20.5 17.2762 20.2762 17.5 20 17.5H7C6.72383 17.5 6.5 17.2762 6.5 17V4C6.5 3.72385 6.72385 3.5 7 3.5H20Z",
    fill: "currentColor",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00009 5.50098C1.44781 5.50098 1.00009 5.94869 1.00009 6.50098V21C1.00009 22.1045 1.89547 23 3.00009 23H17.4983C18.0506 23 18.4983 22.5523 18.4983 22C18.4983 21.4477 18.0506 21 17.4983 21H3.00009V6.50098C3.00009 5.94869 2.55238 5.50098 2.00009 5.50098Z",
    fill: "currentColor",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSelectionIcon);
export default __webpack_public_path__ + "static/media/full-selection-icon.88cd3e3184ef6f570f2401107c5c5c07.svg";
export { ForwardRef as ReactComponent };